'use strict';
/**
 * @author Romatel
 */
import angular from 'angular';
import HazardClassesController from './controller/hazardClasses';
import HazardClassesSelectController from './controller/hazardClassesSelect';
import HazardClassesModalCreateController from './controller/hazardClassesModalCreate';
import HazardClassesModalSelectController from './controller/hazardClassesModalSelect';
import HazardClassesTable from './directive/hazardClassesTable';
import HazardClassesService from './service/hazardClasses';

export default angular.module('investmentProject.hazardClasses', [])
    .controller('HazardClassesController', HazardClassesController)
    .controller('HazardClassesModalCreateController', HazardClassesModalCreateController)
    .controller('HazardClassesModalSelectController', HazardClassesModalSelectController)
    .controller('HazardClassesSelectController', HazardClassesSelectController)
    .directive('hazardClassesTable', HazardClassesTable)
    .factory('HazardClassesService', HazardClassesService)
    .name;
